'use client';

import { useEffect } from 'react';
import { reportClientError } from '@/src/lib/errors/client-error-reporter';

export function GlobalErrorHandler() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleError = (event: ErrorEvent) => {
      event.preventDefault();
      reportClientError(event.error || event.message, {
        type: 'error',
        source: event.filename || null,
        lineno: event.lineno || null,
        colno: event.colno || null,
      });
    };

    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      event.preventDefault();
      const reason = event.reason;
      const error = reason instanceof Error ? reason : new Error(String(reason || 'Unhandled promise rejection'));
      reportClientError(error, {
        type: 'unhandledrejection',
      });
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return null;
}
